<template>
  <sidebar-form-row v-bind="$props" name-cols="8" cols="auto">
    <template #[name]>
      <span class="text-body-2 font-weight-medium">
        {{ value }}
        <span v-html="unit"></span>
      </span>
    </template>
  </sidebar-form-row>
</template>

<script>
import SidebarFormRow from '@/components/SidebarFormRow';

export default {
  name: 'NmtSidebarProfileStat',
  components: {
    SidebarFormRow,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    translationPath: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
